import React, { useEffect, useState } from "react";
import "./choose_user.css";
import { FaUserTie, FaBuilding, FaUserShield } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { localStorageKey, screenPath } from "../../constant/strings";

const ChooseUser = () => {
  const [chooseUser, setChooseUser] = useState("");
  const navigation = useNavigate();

  useEffect(() => {
    const authToken = localStorage.getItem(localStorageKey.authToken);
    const userType = localStorage.getItem(localStorageKey.userType);

    if (authToken && userType) {
      if (userType === "accountant") {
        navigation(screenPath.accountantSelectCompany);
      } else if (userType === "company") {
        navigation(screenPath.dashboardCompanyPage);
      }
    } else {
      navigation(screenPath.chooseUser);
    }
  }, [navigation]);

  const handleSelect = (type) => {
    setChooseUser(type);
  };

  const handleLogin = () => {
    if (chooseUser) {
      navigation(`${screenPath.login}?type=${chooseUser}`);
    }
  };

  return (
    <div className="chooseUser-container">
      <h1 className="chooseUser-title">Choose Your Account Type</h1>
      <p className="chooseUser-subtitle">
        Please select whether you are an accountant or a user.
      </p>

      <div className="chooseUser-options">
        <div
          className={`chooseUser-card ${
            chooseUser === "accountant" ? "active" : ""
          }`}
          onClick={() => handleSelect("accountant")}
        >
          <FaUserTie className="chooseUser-icon" />
          <h2>Accountant</h2>
          <p>Manage clients, review transactions, and handle accounts.</p>
        </div>

        <div
          className={`chooseUser-card ${
            chooseUser === "company" ? "active" : ""
          }`}
          onClick={() => handleSelect("company")}
        >
          <FaBuilding className="chooseUser-icon" />
          <h2>Users</h2>
          <p>
            You can collabrate with your admin, to use and maintain the account.
          </p>
        </div>

        <div
          className={`chooseUser-card ${
            chooseUser === "admin" ? "active" : ""
          }`}
          onClick={() => handleSelect("admin")}
        >
          <FaUserShield className="chooseUser-icon" />
          <h2>Admin</h2>
          <p>
            Manage accountants, invite new users, and oversee all operations.
          </p>
        </div>
      </div>

      {chooseUser && (
        <button className="chooseUser-button" onClick={() => handleLogin()}>
          Continue as {chooseUser.charAt(0).toUpperCase() + chooseUser.slice(1)}
        </button>
      )}
    </div>
  );
};

export default ChooseUser;
